import React, { useEffect, useState } from 'react'
import Snackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'
import { userMessageAtom, userMessageStore, UserMessageType } from '../../atoms/userMessageAtom'

export const UserMessageSnackbar = () => {
    const [messageContext, setMessageContext] = useState<UserMessageType>(null)
    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        const unsubscribe = userMessageStore.sub(userMessageAtom, () => {
            const failure = userMessageStore.get<UserMessageType>(userMessageAtom)
            setMessageContext(failure)
            setIsOpen(true)
        })

        return () => unsubscribe()
    })

    const handleClose = () => setIsOpen(false)

    const severity = messageContext?.type

    return (
        <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            autoHideDuration={3000}
            open={isOpen}
            onClose={handleClose}
        >
            <Alert severity={severity} onClose={handleClose} sx={{ width: '100%' }} variant='filled'>
                {messageContext?.type === 'error' ? (
                    <>
                        {' '}
                        Någonting gick fel, vänligen försök igen.
                        {!!messageContext?.errorCode && (
                            <>
                                <br />
                                <span style={{ fontSize: '0.9em' }}>Felkod: {messageContext.errorCode}</span>
                            </>
                        )}
                    </>
                ) : (
                    messageContext?.message
                )}
            </Alert>
        </Snackbar>
    )
}
